export default __webpack_public_path__ + "static/media/er6.248e3f39.png";